class CategoryHeader extends Component {
    constructor(el) {
        super(el);
        this.clampEl = this.$find('[data-category-text-clamp]');
        this.moreEl = this.$find('[data-category-text-more]');
        this.containerEl = this.$find('[data-category-text-container]');
        if (this.moreEl) {
            this.moreElTextEl = this.moreEl.querySelector('span');
            this.moreText = this.moreElTextEl.innerText || '';
            this.lessText = this.moreEl.dataset.categoryTextMore || '';
        }
        this.containerEl && (this.isTextShown = this.containerEl.classList.contains('is-shown'));
        this.addEventListeners();
    }

    toggleText() {
        if (this.isTextShown) {
            this.moreElTextEl.innerText = this.moreText;
            this.isTextShown = false;
            this.containerEl.classList.remove('is-shown');
        } else {
            this.moreElTextEl.innerText = this.lessText;
            this.isTextShown = true;
            this.containerEl.classList.add('is-shown');
        }
    }

    showOrHideButton() {
        this.moreEl.classList.toggle('u-hidden', (this.clampEl.scrollHeight <= this.clampEl.clientHeight) && !this.isTextShown);
    }

    addEventListeners() {
        this.moreEl && this.moreEl.addEventListener('click', () => this.toggleText());
        this.moreEl && window.addEventListener('resize', () => this.showOrHideButton());
        this.moreEl && window.addEventListener('load', () => this.showOrHideButton());
    }
}